import { useBulkAppointmentUpload } from "@/app/shared/appointments/bulk-upload.hooks";
import { bulkUploadAppointments } from "./bulk-upload.api";

export function useBulkUpload() {
  return useBulkAppointmentUpload(bulkUploadAppointments);
}
